export default __webpack_public_path__ + "static/media/lb-ea.1a0a0dda.webp";